import { render, staticRenderFns } from "./careers.vue?vue&type=template&id=2b38749b&scoped=true&"
import script from "./careers.vue?vue&type=script&lang=js&"
export * from "./careers.vue?vue&type=script&lang=js&"
import style0 from "./careers.vue?vue&type=style&index=0&id=2b38749b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38749b",
  null
  
)

export default component.exports